/* Generated by server/src/auth/write-access-inventory.int.spec.ts. Do not edit by hand. */
import type { WriteAxis } from './membership.js';

/**
 * **Every write route on the office plane, and the least a membership must be
 * able to write to call it** — the server's `@Writes` classification as the
 * booted app's route table reports it, with an undecorated route as `all`.
 *
 * A projection for the dashboard's contract test and its write-side gates, never
 * an input to the fence: `WriteAccessGuard` reads the decorators, and nothing
 * on the server reads this. Change a route's axis on its handler, then
 * regenerate:
 *
 *   NI_WRITE_ROUTES_UPDATE=1 pnpm --filter @ni/server exec vitest run --project integration src/auth/write-access-inventory.int.spec.ts
 */
export const OFFICE_WRITE_ROUTES = {
  'DELETE /orgs/:orgId/events/:id': 'all',
  'DELETE /orgs/:orgId/events/:id/attendees': 'all',
  'DELETE /orgs/:orgId/events/:id/attendees/:nodeId/pick': 'all',
  'DELETE /orgs/:orgId/inputs/:id': 'all',
  'DELETE /orgs/:orgId/organisations/:id': 'all',
  'DELETE /orgs/:orgId/subjects/:id': 'all',
  'PATCH /orgs/:orgId/inputs/:id': 'all',
  'PATCH /orgs/:orgId/reports/:id/preferences': 'all',
  'PATCH /orgs/:orgId/reports/:id/title': 'all',
  'PATCH /orgs/:orgId/security/accounts/:accountId': 'all',
  'PATCH /orgs/:orgId/settings': 'all',
  'POST /orgs/:orgId/decisions/:id/answer': 'all',
  'POST /orgs/:orgId/decisions/:id/needs-info': 'all',
  'POST /orgs/:orgId/events': 'all',
  'POST /orgs/:orgId/events/:id/analyses/:analysis/report': 'all',
  'POST /orgs/:orgId/events/:id/attendees/:nodeId/dismiss': 'all',
  'POST /orgs/:orgId/events/:id/attendees/:nodeId/pick': 'all',
  'POST /orgs/:orgId/events/:id/attendees/:nodeId/promote': 'all',
  'POST /orgs/:orgId/events/:id/attendees/people': 'all',
  'POST /orgs/:orgId/events/:id/scan': 'all',
  'POST /orgs/:orgId/facts/:lineageId/correct': 'all',
  'POST /orgs/:orgId/imports': 'all',
  'POST /orgs/:orgId/imports/:id/cancel': 'all',
  'POST /orgs/:orgId/imports/:id/commit': 'all',
  'POST /orgs/:orgId/imports/:id/file': 'all',
  'POST /orgs/:orgId/imports/:id/messages': 'all',
  'POST /orgs/:orgId/imports/:id/notes/read': 'all',
  'POST /orgs/:orgId/imports/:id/open': 'all',
  'POST /orgs/:orgId/imports/:id/preview': 'all',
  'POST /orgs/:orgId/imports/:id/retry': 'all',
  'POST /orgs/:orgId/imports/:id/rows/:locator': 'all',
  'POST /orgs/:orgId/imports/:id/rows/bulk': 'all',
  'POST /orgs/:orgId/imports/:id/rows/retry': 'all',
  'POST /orgs/:orgId/imports/:id/unwind': 'all',
  'POST /orgs/:orgId/inputs/:id/extract-retry': 'all',
  'POST /orgs/:orgId/interactions/:id/reclassify': 'all',
  'POST /orgs/:orgId/knowledge/:entityId/family': 'all',
  'POST /orgs/:orgId/knowledge/:entityId/join': 'all',
  'POST /orgs/:orgId/knowledge/:entityId/links': 'all',
  'POST /orgs/:orgId/knowledge/:entityId/rename': 'all',
  'POST /orgs/:orgId/merge-triage/:decisionId/undo': 'all',
  'POST /orgs/:orgId/merges/:decisionId/unmerge': 'all',
  'POST /orgs/:orgId/organisations': 'all',
  'POST /orgs/:orgId/organisations/:id/statements': 'all',
  'POST /orgs/:orgId/reports': 'all',
  'POST /orgs/:orgId/reports/:id/archive': 'all',
  'POST /orgs/:orgId/reports/:id/edits': 'all',
  'POST /orgs/:orgId/reports/:id/inputs': 'all',
  'POST /orgs/:orgId/reports/:id/refresh': 'all',
  'POST /orgs/:orgId/reports/:id/revise': 'all',
  'POST /orgs/:orgId/runs/:id/cancel': 'all',
  'POST /orgs/:orgId/runs/:id/resume': 'all',
  'POST /orgs/:orgId/security/accounts': 'all',
  'POST /orgs/:orgId/subjects': 'all',
  'POST /orgs/:orgId/subjects/:id/identity/wrong-person': 'all',
  'POST /orgs/:orgId/subjects/:id/inputs': 'notes',
  'POST /orgs/:orgId/subjects/:id/interactions': 'notes',
  'POST /orgs/:orgId/subjects/:id/profile-links/:anchorId': 'all',
  'POST /orgs/:orgId/subjects/:id/runs': 'all',
  'POST /orgs/:orgId/subjects/:id/status': 'all',
  'PUT /orgs/:orgId/imports/:id/plan': 'all',
} as const satisfies Readonly<Record<string, WriteAxis>>;

export type OfficeWriteRoute = keyof typeof OFFICE_WRITE_ROUTES;
